




































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { MswAppTitle } from '@/shared/msw-app-title';
import uuifComponent from '@/shared/uuifComponent';
import { TableColumnConfig, SortedColumnInfo, ColumnSortRequestData, TableData, TableEntry, ColumnsAdjustRequestData } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { CreateElement, VNode } from 'vue';
import { SwContentToolbar, SwContentToolbarExpand } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { DropMenuItem, SwDropMenu } from '@sonicwall/unified-ui-framework/src/shared/sw-drop-menu';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwExpandableTextfield, SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
// import _ from 'lodash';
import ExportcsvService from '@/shared/msw-exportcsv.service';

const cssPrefix = 'subscription-report';

@Component({
  components: {
    ...uuifComponent,
    MswAppTitle,
    SwContentToolbarExpand,
    SwDropMenu,
    SwIconButton,
    SwExpandableTextfield,
    SwContentToolbar,
    SwTextfield,
  },
})
export default class CloudReport extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  get menuItems(): DropMenuItem[] {
    return [
      {
        id: 'SerialNumber',
        content: this.$t('products.serialnumber')
        .toString(),
      },
      {
        id: 'FriendlyName',
        content: this.$t('products.friendlyName')
        .toString(),
      },
      {
        id: 'Model',
        content: this.$t('report.model')
        .toString(),
      },
      {
        id: 'productGroupName',
        content: this.$t('products.tenantname')
        .toString(),
      },
      {
        id: 'RegDate',
        content: this.$t('report.regstrd')
        .toString(),
      },
      {
        id: 'FirmwareVersion',
        content: this.$t('products.firmwareversion')
        .toString(),
      },
      {
        id: 'LastPingDate',
        content: this.$t('report.lstPingDate')
        .toString(),
      },
    ];
  }
  menuOpened: boolean = false;

  reportData : TableData[] = [];
  sortedColumns: SortedColumnInfo[] = [];
  tempReportData: any = [];
  repName : string = 'CGMS';
  reportHeading : string = '';
  snbUser : string = '';
  reportColumnList : any[] = [];
  exportMenuOpened: boolean = false;
  exportMenuItems: DropMenuItem[] = [
    { id: 'csv', content: 'Export CSV' },
    { id: 'xls', content: 'Export XLS' },
  ];
  address : string = '';
  company : string = '';
  citystate : string = '';
  country : string = '';
  // flter
  search: string = '';
  filterSearch: string = '';
  appliedFilter: any = [];
  showFilterSearch : boolean = false;
  showSearchedTextInHeader : boolean = false;
  textExpanded: boolean = false;
  filterKeys: any = ['SerialNumber', 'FriendlyName', 'Model', 'productGroupName', 'DtRegDate'];
  adjustedColumns: ColumnsAdjustRequestData = {};

  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  reportColumnsConfig : TableColumnConfig[] = [{
    key : 'SerialNumber',
    dataKey: 'SerialNumber',
    title : this.$t('quote.serialNo')
    .toString(),
    sorter: (a: TableEntry, b: TableEntry) => {
      return  (a.SerialNumber || '')
      .localeCompare(b.SerialNumber || '', undefined, {
        numeric: true,
      });
    },
    // tslint:disable-next-line:no-unused
    render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
      return (
       <div>
        <a style="color: #47afe8;" onClick={() => this.serialNumberClick(data.entry.SerialNumber)}>{ data.entry.SerialNumber }</a>
      </div>
    ) as VNode;
    },
    width : 130,
  },
  {
    key : 'FriendlyName',
    dataKey : 'FriendlyName',
    title : this.$t('products.friendlyName')
    .toString(),
    sorter: (a: TableEntry, b: TableEntry) => {
      return  (a.FriendlyName || '')
      .localeCompare(b.FriendlyName || '', undefined, {
        numeric: true,
      });
    },
    width : 200,
  },
  {
    key : 'Model',
    dataKey : 'Model',
    title : this.$t('report.model')
    .toString(),
    sorter: (a: TableEntry, b: TableEntry) => {
      return  (a.Model || '')
      .localeCompare(b.Model || '', undefined, {
        numeric: true,
      });
    },
    width : 200,
  },
  {
    key : 'productGroupName',
    dataKey : 'productGroupName',
    title : this.$t('products.tenantname')
    .toString(),
    sorter: (a: TableEntry, b: TableEntry) => {
      return  (a.productGroupName || '')
      .localeCompare(b.productGroupName || '', undefined, {
        numeric: true,
      });
    },
    width : 200,
  },
  {
    key : 'DtRegDate',
    dataKey : 'RegDate',
    title : this.$t('report.regstrd')
    .toString(),
    sorter: ((a: any, b: any) => {
      const aRegDate: any = new Date(a.DtRegDate);
      const bRegDate: any = new Date(b.DtRegDate);
      return aRegDate - bRegDate;
    }),
    width : 100,
  },
  {
    key: 'FirmwareVersion',
    dataKey: 'FirmwareVersion',
    title: this.$t('products.firmwareversion')
    .toString(),
    sorter: (a: TableEntry, b: TableEntry) => {
      return  (a.FirmwareVersion || '')
      .localeCompare(b.FirmwareVersion || '', undefined, {
        numeric: true,
      });
    },
    width: 100,
  },
  {
    key: 'DtLastPingDate',
    dataKey: 'DtLastPingDate',
    title: this.$t('report.lstPingDate')
    .toString(),
    width: 150,
    sorter: ((a: any, b: any) => {
      const aLastPingDate: any = new Date(a.DtLastPingDate);
      const bLastPingDate: any = new Date(b.DtLastPingDate);
      return aLastPingDate - bLastPingDate;
    }),
  }];
  created() {
    if (this.$router.currentRoute.query.repName === 'CAP') {
      this.repName = 'CAP';
      this.reportHeading = this.$t('report.cldClaimedStatus')
      .toString();
    } else {
      this.repName = 'CGMS';
      this.reportHeading = this.$t('report.cldReportStatus')
      .toString();
    }
    if (this.$router.currentRoute.query.snbuser) {
      this.snbUser =  this.$router.currentRoute.query.snbuser as string;
      this.getUserDetailsAndReportDetails(this.$router.currentRoute.query.snbuser);
    } else {
      this.getUserDetailsAndReportDetails(this.$store.getters.getUserId);
    }
    // console.warn(this.$store.getters.getUserId);
  }
  getUserDetailsAndReportDetails(userId : any) {
    const request  = {
      username : this.snbUser ? this.snbUser :  this.$store.getters.getUserId,
      tenant : '',
      repName : this.repName,
    };
    Promise.all([
      this.$store.dispatch('SubscriptionReportStoreModule/getSubscrReport', request),
      this.$store.dispatch('SubscriptionReportStoreModule/getUserDetails', userId),
    ])
    .then((response : any) => {
      // console.warn(response);
      if (response[0]) {
        console.warn(response[0].content.colnames);
        if (response[0].content.colnames && response[0].content.colnames !== '' && response[0].content.Records.length > 0) {
          this.reportColumnList = response[0].content.colnames.split('^');
          this.reportColumnList.forEach((ele : any, index : any) => {
            if (index < 10) {
              this.reportColumnsConfig.push({
                key : `col${(index + 1)}ServiceExpiryDate`,
                dataKey : `col${(index + 1)}ServiceExpiryDate`,
                title : ele,
                tooltip: { content: ele, compact: true },
                render: (h: CreateElement, data: { entry: TableEntry }): VNode => {// tslint:disable-line
                  // console.warn(data.entry);
                  return (
                      <div onClick={ () => {
                        this.$router.push({ path: `/m/feature/products?serialNumber=${data.entry.SerialNumber}&tab=Licenses` })
                          .catch((routeError: any) => {
                            console.warn(routeError);
                          });
                      }
                        }>
                        {data.entry[`col${(index + 1)}ServiceExpiryDate`] !== undefined && data.entry[`col${(index + 1)}ServiceExpiryDate`] !== 'N/A' ? <a style="color: #47afe8;" onClick={() => this.otherColumnClick(data.entry)}>{ data.entry[`col${(index + 1)}ServiceExpiryDate`] }</a>
                        : data.entry[`col${(index + 1)}ServiceExpiryDate`] }
                      </div>
                    ) as VNode;
                  // if (data.entry[`col${(index + 1)}ServiceExpiryDate`] !== 'N/A') {
                  //   return (
                  //     <div>
                  //       <a style="color: #47afe8;" onClick={() => this.otherColumnClick(data.entry)}>{ data.entry[`col${(index + 1)}ServiceExpiryDate`] }</a>
                  //     </div>
                  //   ) as VNode;
                  // }
                  // if (data.entry[`col${(index + 1)}ServiceExpiryDate`] === 'N/A') {
                  //   return (
                  //     <div>
                  //     { data.entry[`col${(index + 1)}ServiceExpiryDate`] }
                  //     </div>
                  //   ) as VNode;
                  // }
                },
              });
              this.filterKeys.push(`col${(index + 1)}ServiceExpiryDate`);
              this.menuItems.push({ id: `col${(index + 1)}ServiceExpiryDate`, content: ele });
            }
          });
        }
      }
      this.assignReportResponse(response[0]);
      this.address = response[1].content.companyAddress;
      this.company = response[1].content.companyName;
      if (response[1].content.companyAddress1) {
        this.address += `, ${response[1].content.companyAddress1}`;
      }
      this.citystate = `${response[1].content.companyCity} , ${response[1].content.companyState}`;
      if (response[1].content.companyState === '') {
        this.citystate += response[1].content.companyProvince;
      }
      this.country = `${response[1].content.companyCountryName} , ${response[1].content.companyZipCode}`;
    })
    .catch((errResponse: any) => {
      console.warn(errResponse);
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Something went wrong' });
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }
  getReportDetails() {
    const request  = {
      username : this.snbUser ? this.snbUser :  this.$store.getters.getUserId,
      tenant : '',
      repName : this.repName,
    };
    this.$store.dispatch('SubscriptionReportStoreModule/getSubscrReport', request)
    .then((response : any) => {
      console.warn('api response for reports ', response);
      this.assignReportResponse(response);
    });
  }
  onFilterClick(filterItem : any) {
    this.menuOpened = false;
    let removeIndex : number = -1;
    this.menuItems.forEach((element: any, i: number) => {
      if (element.id === filterItem) {
        removeIndex = i;
      }
    });
    if (removeIndex !== -1) {
      this.appliedFilter.push(
        { id: this.menuItems[removeIndex].id,
          content: this.menuItems[removeIndex].content,
          value: '',
        });
      this.filterSearch = '';
      this.showFilterSearch = true;
      setTimeout(() => {
        const filterInput = document.getElementById('filtersearch') as HTMLElement;
        // console.warn(filterInput);
        if (filterInput) {
          filterInput.children[0]
            .getElementsByTagName('input')[0]
            .focus();
        }
      },         200);
        // const inputEl = this.$refs.filterSelect as SwTextfield;
        // console.warn(inputEl);
        // if (inputEl) { inputEl.focus(); }
      // if (this.$refs.refSearchField as SwTextfield) {
      //   console.warn(this.$refs.refSearchField);
      //   (this.$refs.refSearchField as SwTextfield).isFocus = true;
      // }
    }
    // console.warn(this.appliedFilter);
  }
  initiateFilter(event : any, filterId : number) {
    if (event.keyCode === 13) {
      if (filterId === undefined) {
        this.applyFilter();
      } else {
        this.setFilterValue(event, filterId);
      }
    }
  }
  setFilterValue(event = undefined, index: number) {
    if (event !== undefined && this.filterSearch === '') {
      this.removeFilterBox(index);
    } else {
      this.appliedFilter.forEach((element : any, i : number) => {
        if (i === index) {
          if (event !== undefined) {
            element.value = this.filterSearch;
            this.showFilterSearch = false;
          }
        }
      });
      this.applyFilter();
    }
  }
  removeFilterBox(id: number) {
    console.warn(id);
    console.warn(this.appliedFilter);
    this.filterSearch = '';
    this.appliedFilter[id].value = '';
    if (id > -1) {
      this.appliedFilter[id].value = '';
      this.appliedFilter.splice(id, 1);
    }
    this.applyFilter();
    console.warn(this.appliedFilter);
  }
  clearAllFilters() {
    this.appliedFilter.forEach((element : any) => {
      element.value = '';
    });
    this.appliedFilter = [];
    this.search = '';
    this.showFilterSearch = false;
    this.applyFilter();
  }
  assignReportResponse(response : any) {
    console.warn(response);
    this.tempReportData = [];
    this.reportData = [];
    console.warn(this.menuItems);
    this.reportData = response.content.Records.map((ele : any, index : any) => {
      ele._key = index.toString();
      return ele;
    });
    this.tempReportData = this.reportData;
    console.warn(this.reportData);
    this.$store.commit('stopLoading');
  }
  applyFilter(isExternal: boolean = false) {
    if (!isExternal) {
      this.reportData = this.tempReportData;
    }
    if (this.appliedFilter.length > 0) {
      this.appliedFilter.forEach((element : any) => {
        console.warn(element);
        this.reportData = this.reportData.filter((order : any) => {
          const elementValueArray = element.value.split(',');
          let srcValue : string = '';
          if (order[element.id] === undefined) srcValue = '';
          else srcValue = order[element.id].toUpperCase();
          let flag = 0;
          elementValueArray.every((elementValue : any) => {
            if (srcValue.indexOf(elementValue.trim()
            .toUpperCase()) >= 0) {
              flag = 1;
              return false;
            }
            if (srcValue.indexOf(elementValue.trim()
            .toUpperCase()) < 0) {
              return true;
            }
          });
          if (flag === 1) {
            return true;
          }
        });
      });
    }
    if (this.search !== '') {
      this.textExpanded = false;
      const key : string = this.search.toUpperCase();
      let flag : number = 0;
      const searchKeys = this.filterKeys;
      this.reportData = this.reportData.filter((item : any) => {
        flag = 0;
        searchKeys.forEach((field: any) => {
          if (item[field] && (item[field].toUpperCase()).indexOf(key) >= 0) {
            flag = 1;
            return false;
          }
          if (item[field] && (item[field].toUpperCase()).indexOf(key) < 0) {
            return true;
          }
        });
        if (flag === 1) {
          return true;
        }
      });
      this.showSearchedTextInHeader = true;
    }
  }
  clearFilter() {
    this.search = '';
    this.showSearchedTextInHeader = false;
    this.applyFilter();
  }
  serialNumberClick(val : any) {
    this.$router.push({ path: `/m/feature/products?serialNumber=${val}` })
    .catch((routeError: any) => {
      console.warn(routeError);
    });
  }
  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }
  otherColumnClick(val: any) {
    console.warn('on click other column', val);
  }
  get tableHeight() {
    return 'calc(100vh - 335px)';
  }
  onChangeExport(itemId: string) {
    if (itemId === 'csv') {
      this.exportCsv();
    } else {
      this.exportXls();
    }
  }
  exportXls() {
    this.startExport(this.mapDataForExportExcel(this.reportData), 'Report.xls');
  }
  startExport(productsList:any, name:string) {
    const XLSX = require('xlsx');
    const link = document.createElement('a');
    if (name.includes('.xls')) {
      const excel = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(productsList);
      ws['!autofilter'] = { ref: ws['!ref'] };
      XLSX.utils.book_append_sheet(excel, ws, 'Report');
      const finalExel = XLSX.writeFile(excel, name.concat('x'));
      const blobOb = new Blob(finalExel, { type: 'text/xls;charset=utf-8;' });
      link.href = URL.createObjectURL(blobOb);
      link.setAttribute('style', 'font-weight: bold');
      link.download = name.concat('x');
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  mapDataForExportExcel(data: any[]) {
    let tempArr: any = [];
    tempArr = [];
    const itemHeader: any = [];
    console.warn(this.reportColumnsConfig);
    this.reportColumnsConfig.map((ele: any) => {
      itemHeader.push(ele.title);
    });
    const tempJson: any = [];
    if (data.length === 0) {
      const emptyObj = {};
      this.reportColumnsConfig.forEach((item) => {
        if (item.dataKey) {
          // @ts-ignore
          emptyObj[item.title] = '';
        }
      });
      tempJson.push(emptyObj);
    }
    data.map((dataItem:any) => {
      console.warn(dataItem);
      const obj = {};
      this.reportColumnsConfig.forEach((item) => {
        if (item.dataKey) {
          // @ts-ignore
          obj[item.title] = dataItem[item.dataKey] !== undefined ? dataItem[item.dataKey] : '';

          if (item.dataKey.toLowerCase()
            .includes('date') &&
            // @ts-ignore
            obj[item.title] && obj[item.title] !== 'N/A') {
            // @ts-ignore
            obj[item.title] = new Date(obj[item.title]);
          }
        }
      });
      tempJson.push(obj);
    });
    tempArr = tempArr.concat(tempJson);
    return tempArr;
  }
  exportCsv() {
    ExportcsvService.export(this.mapToExport(this.reportData), 'Report.csv');
  }
  onClickMultiMenuButton() {
    this.menuOpened = !this.menuOpened;
  }
  mapToExport(reportData : any) {
    const reportDataFitered : any[] = [];
    reportData.forEach((object : any) => {
      const obj : any = {};
      this.menuItems.forEach((ele : any) => {
        obj[`${ele.content}`] = object[`${ele.id}`];
      });
      reportDataFitered.push(obj);
    });
    return reportDataFitered;
  }
  printExport() {
    // const reportDataPrint = this.mapToExport(this.reportData);
    let result = `<html><head></head><body><link id='lnkstyle' rel='stylesheet'href='https://www.mysonicwall.com/App_Themes/Blue/Blue.css' type='text/css'><title>mySonicWALL.com - Subscription report - Printable version</title>
    <table width='900' cellspacing='0' cellpadding='0' border='0'><tbody><tr><td width='27'><img id='space1' src='https://www.mysonicwall.com/App_Themes/Blue/images/spacer.gif' style='width:27px;border-width:0px;'>
    </td><td><table width='100%' cellspacing='0' cellpadding='0' border='0' align='center'><tbody>
    <tr><td class='style1'><input name='imgfooterlogo' id='imgfooterlogo' src='https://www.mysonicwall.com/images/generic-footer-thin.jpg'
    style='border-width: 0px;' type='image'></td><td align='right'><table width='100%' cellspacing='0'
    cellpadding='0' border='0' align='center'><tbody><tr><td align='right'><a href='#' id='printsec'
    onclick='var obj = document.getElementById(&quot;imgfooterlogoPrinter&quot;);
    var objlnk = document.getElementById(&quot;printsec&quot;);
    if (obj.style.visibility == &quot;hidden&quot;) { obj.style.visibility =&quot;visible&quot;;objlnk.style.visibility =&quot;visible&quot;; }
    else { obj.style.visibility = &quot;hidden&quot;;objlnk.style.visibility = &quot;hidden&quot;; };window.print();if (obj.style.visibility == &quot;hidden&quot;)
    { obj.style.visibility = &quot;visible&quot;; objlnk.style.visibility = &quot;visible&quot;;} else { obj.style.visibility = &quot;hidden&quot;;  objlnk.style.visibility = &quot;hidden&quot;;};'>
    <input name='imgfooterlogoPrinter' id='imgfooterlogoPrinter' src='https://www.mysonicwall.com/App_Themes/Blue/images/Printer.gif' style='border-width: 0px;' type='image'><br>
    <span id='lblPrint' title='Print this page'>Print this page</span></a></td></tr></tbody></table></td></tr></tbody></table><br><div><img id='dot3' src='https://www.mysonicwall.com/images/dotted_750.GIF' style='height:1px;width:900px;border-width:0px;'></div>`;
    result += "<br><br><div id='userinfo' style='width:500px;'><span class='regbld'><span id='lbluserinfo' class='subheader'>User Details: </span> </span><br><br>";
    result += "<table width='500' cellspacing='0' cellpadding='0'><tbody>";
    // tslint:disable-next-line:max-line-length
    result += `<tr><td><span id='lblusernametext' class='main_contents'>Username</span>  </td> <td> <span id='lblusernameval' class='main_contents'>: ${this.snbUser ? this.snbUser : this.$router.currentRoute.query.snbuser}'</span></td></tr>`;
    // tslint:disable-next-line:max-line-length
    result += `<tr><td><span id='lblcompanytext' class='main_contents'>Company</span>  </td><td><span id='lblcompanyval' class='main_contents'>: ${this.company} + '</span>  <br></td> </tr>`;
    result += `<tr><td valign='top'><span id='lblstreetaddresstext' class='main_contents'>Street Address</span> </td> <td><span id='lblstreetaddressval' class='main_contents'>: ${this.address}</span></td></tr>`;
    // tslint:disable-next-line:max-line-length
    result += `<tr><td><span id='lblcitystatetext' class='main_contents'>City, State</span> </td> <td><span id='lblcitystateval' class='main_contents'>: " ${this.citystate}</span></td></tr>`;
    result += `<tr><td><span id='lblcountrypostaltext' class='main_contents'>Country, Postal Code</span>  </td> <td><span id='lblcountrypostalval' class='main_contents'>: ${this.country}</span></td></tr>`;
    result += '</tbody></table><br><br></div>';

    result += '</td></tr></tbody></table>';
    result += "<table width='900' cellspacing='0' cellpadding='0' border='0'><tr><td width='27'><img id='space1' src='https://www.mysonicwall.com/App_Themes/Blue/images/spacer.gif' style='width:27px;border-width:0px;'></td><td>";

    result += "<table width='1400'  border='1' style='border-collapse:collapse'><tr><th style='width:2%;'></th>";
    this.menuItems.forEach((ele : any) => {
      result += `<th style='width:10%;text-align: start;'><span  class='subheader'>${ele.content}</span></th>`;
    });
    result += '</tr>';
    this.reportData.forEach((ele : any, index : any) => {
      result += `<tr><td>${index + 1}</td>`;
      this.menuItems.forEach((item : any) => {
        const data = ele[`${item.id}`];
        result += `<td style='margin-left: 5px;'>${data ? data : ''}</td>`;
      });
      result += '</tr>';
    });
    result += '</table></td></tr></table>';
    result += `<br><table width='900' cellspacing='0' cellpadding='0' border='0'><tbody><tr><td width='27'>
    <img id='space1' src='https://www.mysonicwall.com/App_Themes/Blue/images/spacer.gif' style='width:27px;border-width:0px;'></td>
    <td><p><img id='dot3' src='https://www.mysonicwall.com/images/dotted_750.GIF' style='height:1px;width:900px;border-width:0px;'>
    <br><br><span id='lblsupporttext' class='subheader'>SONICWALL CUSTOMER SUPPORT</span><br>
    <span id='lblhelplinetext' class='main_contents'>1.888.793.2830</span><br><a id='hlemail' href='mailto:servicesales@sonicwall.com'>
    servicesales@sonicwall.com</a></p></td></tr></tbody></table><br>`;
    result += '</body></html>';

    const w = window.open();
    w!.document.body.innerHTML = result;

  }
}
